<template>
  <div class="common-top-bar head-active">
    <div class="common-top-bar-inside-wrapper">
      <div class="common-top-bar-menu-logo-area" style="cursor: default;">
        <el-image v-if="companyLogo" class="top-bar-logo" :src="companyLogo" alt="logo"></el-image>
        <img v-else class="top-bar-logo" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/default_icon.png" alt="logo" style="width:40px"/>
      </div>
      <div class="common-top-bar-menu-self">
        <div class="nav-tabs-container">
          <div class="tab-text" :class="{ 'active': type == menu.id }" v-if="menu.show" v-for="(menu, index) in configList" :key="index" @click.stop="handSwitchSub(menu)">
            <div class="menu-horizontal">
              {{ menu.name }}
              <i v-if="menu.child_node_list" class="el-icon-arrow-down"></i>
            </div>
            <transition name="el-zoom-in-top">
              <ul class="submenu" v-if="menu.child_node_list">
                <li v-for="(child, i) in menu.child_node_list" :key="i" @click.stop="handSwitchItem(child)" v-if="child.show">
                  <!-- <img :src="child.logo_url" alt="" /> -->
                  <span> {{ child.name }}</span>
                </li>
              </ul>
            </transition>
          </div>
          <!-- <div class="tab-text openapi-text" @click.stop="openApiDocument">OpenAPI文档</div> -->
          <!-- <div class="bottom-line" v-if="type == 0||type" :style="{ transform: `translateX(${barStyle}px)`}" /> -->
        </div>
      </div>
      <div class="top-bar-user-info">
        <!-- <div class="top-bar-language" :class="{'languageAct':contactUsAct}" @click="toPushUrl('aboutUs')"><span>关于</span></div> -->
        <div class="user" v-if="this.$store.getters.isLogin">
          <div class="header-user-box">
            <div class="header-user-avatar">
              <el-image v-if="$store.getters.userData.avatar" class="header-user-img" :src="$store.getters.userData.avatar" alt=""></el-image>
              <img v-else class="header-user-img" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/userImg.png" width="32px" height="32px" alt="" />
            </div>
            <i class="el-icon-arrow-down"></i>
          </div>
          <ul class="dropdown">
            <li class="flex-between">
              <span>{{phoneNumFilter($store.getters.userData.phone)}}</span>
              <span><i class="iconfont icon-yirenzheng-copy " :class="{'green':$store.getters.userData.companyStatus == 20}"></i></span>
            </li>
            <li class="flex-between" @click="toPushUrl('homePage')">
              <span>用户中心</span>
              <span><i class="el-icon-arrow-right"></i></span>
            </li>
            <li class="logout" @click="logout">退出登录</li>
          </ul>
        </div>
        <div class="login-box" v-else>
          <span class="register" @click="toPushUrl('register')">登录/注册</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpAjax,httpAgent } from '@/api/ajax'
import { configList } from "../mock"
import { mapActions } from "vuex"


export default {
  name: "Header",
  data () {
    return {
      configList,
      type: "",
      loginMenu: null, //   用户需要登入之前保存的数据
      contactUsAct: false,
      goCompanyInfo: false,
      companyLogo: ''
    }
  },
  watch: {
    $route (to, from) {
      this.contactUsAct = false
      if (to.path == '/aboutUs') {
        this.contactUsAct = true
        sessionStorage.removeItem("tabIndex")
        this.type = null
      } else {
        this.getRouterObg(to)
      }
    }
  },
  mounted () {
    if (this.$store.getters.isLogin) {
      this.getUserData()
    }
    if (this.$route.path == '/aboutUs') {
      this.contactUsAct = true
    } else {
      this.getRouterObg(this.$route)
    }
    var that = this
    window.addEventListener("message", function (e) {
      if (e.data.isLogout) {
        console.log('1.0退出')
        localStorage.removeItem('userToken')
        localStorage.removeItem('userData')
        that.$store.dispatch('user/setIsLogin', false)
      }
    }, false)
    this.getDomainInfo();
  },
  methods: {
    ...mapActions(['user/getUserData']),
    // 当前路由对象
    getRouterObg (to) {
      let routerListItem = this.ruleValidate(this.configList, to.path)
      sessionStorage.setItem('tabIndex', routerListItem.id || null)
      this.type = routerListItem.id || null
    },
    //  返回当前路由对象
    ruleValidate (list, path) {
      let flag = true
      var obg = {}
      function judgeChildren (list) {
        list.forEach(e => {
          if (!flag) {
            return
          }
          if (e.jump_url == path) {
            obg = e
            flag = false
            return
          } else if (e.child_node_list && e.child_node_list.length) {
            judgeChildren(e.child_node_list)
          }
        })
      }
      judgeChildren(list)
      return obg
    },

    handSwitchSub (menu) {
      if (menu.login_type) {
        //  是否登入
        if (this.$store.getters.isLogin) {
          if (menu.enterpriseCertification) {
            // 是否企业认证
            this.getCompanyApply(() => {
              this.type = menu.id
              if (menu.openNewWindow) {
                window.open(menu.jump_url)
              } else if (menu.replaceUrl) {
                setTimeout(() => {
                  window.location.href = menu.jump_url  //延迟跳转，让loginPostMessage调用代理系统通信
                }, 10)
              } else {
                this.$router.push({ path: menu.jump_url })
                sessionStorage.setItem("tabIndex", menu.id)
              }
              if (menu.name.indexOf("代理") > -1) {
                this.loginPostMessage()
              }
            })
          } else {
            if (menu.openNewWindow) {
              window.open(menu.jump_url)
            } else if (menu.replaceUrl) {
              setTimeout(() => {
                window.location.href = menu.jump_url  //延迟跳转，让loginPostMessage调用代理系统通信
              }, 10)
            } else {
              this.type = menu.id
              this.$router.push({ path: menu.jump_url })
              sessionStorage.setItem("tabIndex", menu.id)
            }
            if (menu.name.indexOf("代理") > -1) {
              this.loginPostMessage()
            }
          }
        } else {
          this.$message({ message: '请先登录', type: 'warning' })
          this.$router.push({ name: "register" })
        }
      } else {
        this.$router.push({ path: menu.jump_url })
        sessionStorage.setItem("tabIndex", menu.id)
      }

    },

    handSwitchItem (menu) {
      this.type = menu.id
      //  是否登入
      if (this.$store.getters.isLogin) {
        // 是否企业认证
        this.getCompanyApply(() => {
          if (menu.productCode == 'vgm' || menu.productCode == 'shcps') {
            this.getOpenStatus(menu.productCode, () => {
              this.$router.push({ path: menu.jump_url })
              sessionStorage.setItem("tabIndex", menu.id)
            })
          }
        })
      } else {
        this.$message({ message: '请先登录', type: 'warning' })
        this.$router.push({ name: "register" })
      }
    },

    // 获取公司认证信息
    getCompanyApply (fn) {
      httpAjax({
        url: `/services/company/currentCompany`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          if (!response.data) {
            this.$message({ message: '请先认证企业信息', type: 'warning' })
            this.$router.push({ path: 'certification' })
            return
          }
          if (response.data && response.data.status === 20) {
            this.getUserData(() => {
              fn()
            })
          } else {
            this.$message({ message: '请先认证企业信息', type: 'warning' })
            this.$router.push({ path: 'certification' })
          }
        } else {
          this.$message({
            message: response.msg,
            type: "error",
          })
        }
      })
    },
    // 获取用户信息
    getUserData (fn) {
      httpAjax({
        url: `/services/user/currentUser`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          localStorage.setItem('userData', JSON.stringify(response.data))
          this['user/getUserData']()
          fn && fn()
        }
      })
    },

    //  获取当前产品的开通状态
    getOpenStatus (productCode, fn) {
      httpAgent({
        url: `/agent/product/status`,
        method: "get",
        data: { productCode }
      }).then((response) => {
        if (response == 1) {
          fn()
        } else {
          this.$message({
            message: '抱歉，你还没有使用产品的权限',
            type: "error",
          })
        }
      })
    },

    //  路由跳转
    toPushUrl (name) {
      this.$router.push({ name })
    },
    // 手机号
    phoneNumFilter (phone) {
      var newphone = phone && (phone.substr(0, 3) + '****' + phone.substr(phone.length - 4))
      return newphone
    },
    //  退出
    logout () {
      this.$store.dispatch("user/logout").then(() => {
        this.$router.push({ name: "login" })
        this.$message({
          message: '退出成功',
          type: 'success',
          offset: 80
        })
        this.logoutPostMessage()//通知代理系统退出成功
      })
    },
    //打开openApi文档
    openApiDocument () {
      if (this.$store.getters.isLogin) {
        if (this.goCompanyInfo) {
          this.$router.push({
            name: 'user',
            params: { menuIndex: 3 }
          })
        } else {
          window.open("https://open.eline56.com/doc/")
        }
      } else {
        this.$message({
          message: '请先登录',
          type: 'warning'
        })
        this.$router.push({ name: "register" })
      }
    },
    //退出之后通知代理系统退出成功
    logoutPostMessage () {
      if (window.frames[0]) {
        window.frames[0].postMessage({ isLogout: true }, '*')
      }
    },
    //登录之后通知代理系统登录成功
    loginPostMessage () {
      if (window.frames[0]) {
        let res = {
          data: {
            token: localStorage.getItem('userToken'),
            user: localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')),
            dataRouter: '[]'
          }
        }
        window.frames[0].postMessage(res, '*')
      }
    },
    //获取当前域名企业信息
    getDomainInfo () {
      httpAgent({
        url: `${location.hostname == 'localhost' ? 'http://gateway.eline56.test' : ''}/agent/config/preGet`,
        method: "get",
      }).then((res) => {
        if (res.id) {
          if(res.companyLogo){
            if(res.companyLogo.indexOf('http') > -1){
              this.companyLogo = res.companyLogo
            }else{
              this.companyLogo = 'https://' + res.companyLogo
            }
          }
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = this.companyLogo;
          document.getElementsByTagName('head')[0].appendChild(link);
        }else{
          this.$router.push({
            name:'notFind'
          })
        }
      })
    },
    goHome(){
      this.$router.push({ name: 'register', })
    }
  }
}
</script>


<style scoped lang="less">
.common-top-bar {
  width: 100%;
  height: 60px;
  box-shadow: 0px 5px 4px 0px rgba(0, 0, 0, 0.04);
  background: rgba(255, 255, 255, 0.5);
  color: white;
  position: fixed;
  z-index: 99;

  .common-top-bar-inside-wrapper {
    box-sizing: border-box;
    padding: 0 48px;
    // width: 1200px;
    // padding: 0 78px;
    height: 100%;
    min-width: 1164px;
    max-width: 100%;
    // margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .common-top-bar-menu-logo-area {
      width: 190px;
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      .top-bar-logo {
        max-width: 160px;
        height: 40px;
        // cursor: pointer;
        // height: 32px;
      }
    }
  }
  .common-top-bar-menu-self {
    flex: 1;
    .nav-tabs-container {
      position: relative;
      .tab-text {
        float: left;
        padding: 18px 20px 20px 20px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        position: relative;
      }
      .active {
        font-weight: 500;
        color: #1d73ff;
      }
      .tab-text:hover .submenu {
        display: block;
      }
      .tab-text:hover .menu-horizontal {
        color: #1d73ff;
      }
      .openapi-text:hover {
        color: #1d73ff;
      }
      .bottom-line {
        width: 50px;
        height: 4px;
        border-radius: 4px;
        position: absolute;
        top: 52px;
        transition: transform 0.3s, -webkit-transform 0.3s;
        background-color: #1d73ff;
        cursor: pointer;
        z-index: 1;
      }
      .submenu {
        position: absolute;
        top: 61px;
        left: -61px;
        z-index: 999;
        width: 232px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        background: white;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        display: none;
        overflow: hidden;
        li {
          width: 232px;
          height: 50px;
          list-style: none;
          text-align: left;
          display: flex;
          align-items: center;
          font-size: 14px;
          box-sizing: border-box;
          padding-left: 24px;
          img {
            width: 12px;
            height: 12px;
            margin-right: 6px;
          }
        }
        li:hover {
          color: #1d73ff;
          background: #d7f0ff;
        }
      }
    }
  }
  .top-bar-language {
    padding: 0 16px;
    .contactus {
      line-height: 30px;
    }
    span {
      padding: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
    }
    span:hover {
      color: #1d73ff;
    }
  }
  .login-box {
    .vertical {
      padding: 16px;
    }
    .register {
      display: inline-block;
      width: 90px;
      height: 28px;
      background: #1d73ff;
      border-radius: 13px;
      text-align: center;
      line-height: 28px;
      color: white;
      cursor: pointer;
    }
  }
  .info-operate-area {
    position: relative;
    display: flex;
    align-items: center;
  }
  .top-bar-user-info {
    display: flex;
    align-items: center;
    height: 70px;
    position: relative;
    .user {
      height: 100%;
      display: flex;
      align-items: center;
      .header-user-box {
        width: 90px;
        height: 48px;
        background: white;
        border-radius: 4px;
        overflow: hidden;
        display: flex;
        align-items: center;
        cursor: pointer;
        .header-user-avatar {
          width: 32px;
          height: 32px;
          margin: 5px 12px 5px 14px;
          border-radius: 4px;
          background-color: #95b2ff;
          text-align: center;
          line-height: 30px;
          & > span {
            color: white;
            font-size: 22px;
          }
        }
        .el-icon-arrow-down {
          font-size: 10px;
          // color: #333333;
          color: white;
        }
      }
    }

    .header-user-box:hover {
      background: #f5f5f5;
      .el-icon-arrow-down {
        color: #333333;
      }
    }

    .header-user-info {
      font-size: 14px;
      color: #222222;
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .dropdown {
    position: absolute;
    top: 65px;
    left: -96px;
    z-index: 999;
    width: 232px;
    font-size: 14px;
    font-weight: 400;
    background: white;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    display: none;
    overflow: hidden;
    li {
      width: 100%;
      height: 50px;
      line-height: 50px;
      list-style: none;
      text-align: center;
      font-size: 14px;
      box-sizing: border-box;
      padding: 0 24px;
      color: #333333;
      cursor: pointer;
      img {
        width: 12px;
        height: 12px;
        margin-right: 6px;
      }
      .iconfont {
        color: #999999;
      }
      .green {
        color: #12bf1b;
      }
    }
    .flex-between {
      display: flex;
      justify-content: space-between;
    }
    li:hover {
      color: #1d73ff;
      background: #d7f0ff;
    }
  }

  .user:hover .dropdown {
    display: block;
  }
}

.languageAct span {
  font-weight: bold !important;
  color: #1d73ff !important;
}

.head-active {
  color: #222222;
  background-color: white;
}
</style>
